<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 32 32"
  >
    <g fill="none">
      <g filter="url(#pointingupsvgIDa)">
        <path
          fill="url(#pointingupsvgIDb)"
          d="M4.116 18.12c-1.24-.86-1.701-2.597-.888-3.849a2.657 2.657 0 0 1 3.703-.781l2.61 1.695V4.655a2.637 2.637 0 0 1 5.274 0v4.284a2.493 2.493 0 0 1 4.563.344a2.724 2.724 0 0 1 4.487.884a2.723 2.723 0 0 1 4.492 2.07v3.102l-.001.104v4.859c0 1.431-.848 3.878-2.51 6.022a9.11 9.11 0 0 1-.537.65a9.206 9.206 0 0 1-6.832 3.008a9.196 9.196 0 0 1-7.577-3.944c-.604-.833-.892-1.507-1.179-2.176c-.22-.513-.438-1.023-.796-1.601c-.567-.913-1.4-1.59-1.865-1.969l-.099-.08h.002l-2.847-2.093Z"
        />
        <path
          fill="url(#pointingupsvgIDc)"
          d="M4.116 18.12c-1.24-.86-1.701-2.597-.888-3.849a2.657 2.657 0 0 1 3.703-.781l2.61 1.695V4.655a2.637 2.637 0 0 1 5.274 0v4.284a2.493 2.493 0 0 1 4.563.344a2.724 2.724 0 0 1 4.487.884a2.723 2.723 0 0 1 4.492 2.07v3.102l-.001.104v4.859c0 1.431-.848 3.878-2.51 6.022a9.11 9.11 0 0 1-.537.65a9.206 9.206 0 0 1-6.832 3.008a9.196 9.196 0 0 1-7.577-3.944c-.604-.833-.892-1.507-1.179-2.176c-.22-.513-.438-1.023-.796-1.601c-.567-.913-1.4-1.59-1.865-1.969l-.099-.08h.002l-2.847-2.093Z"
        />
        <path
          fill="url(#pointingupsvgIDd)"
          d="M4.116 18.12c-1.24-.86-1.701-2.597-.888-3.849a2.657 2.657 0 0 1 3.703-.781l2.61 1.695V4.655a2.637 2.637 0 0 1 5.274 0v4.284a2.493 2.493 0 0 1 4.563.344a2.724 2.724 0 0 1 4.487.884a2.723 2.723 0 0 1 4.492 2.07v3.102l-.001.104v4.859c0 1.431-.848 3.878-2.51 6.022a9.11 9.11 0 0 1-.537.65a9.206 9.206 0 0 1-6.832 3.008a9.196 9.196 0 0 1-7.577-3.944c-.604-.833-.892-1.507-1.179-2.176c-.22-.513-.438-1.023-.796-1.601c-.567-.913-1.4-1.59-1.865-1.969l-.099-.08h.002l-2.847-2.093Z"
        />
        <path
          fill="url(#pointingupsvgIDe)"
          d="M4.116 18.12c-1.24-.86-1.701-2.597-.888-3.849a2.657 2.657 0 0 1 3.703-.781l2.61 1.695V4.655a2.637 2.637 0 0 1 5.274 0v4.284a2.493 2.493 0 0 1 4.563.344a2.724 2.724 0 0 1 4.487.884a2.723 2.723 0 0 1 4.492 2.07v3.102l-.001.104v4.859c0 1.431-.848 3.878-2.51 6.022a9.11 9.11 0 0 1-.537.65a9.206 9.206 0 0 1-6.832 3.008a9.196 9.196 0 0 1-7.577-3.944c-.604-.833-.892-1.507-1.179-2.176c-.22-.513-.438-1.023-.796-1.601c-.567-.913-1.4-1.59-1.865-1.969l-.099-.08h.002l-2.847-2.093Z"
        />
        <path
          fill="url(#pointingupsvgIDf)"
          d="M4.116 18.12c-1.24-.86-1.701-2.597-.888-3.849a2.657 2.657 0 0 1 3.703-.781l2.61 1.695V4.655a2.637 2.637 0 0 1 5.274 0v4.284a2.493 2.493 0 0 1 4.563.344a2.724 2.724 0 0 1 4.487.884a2.723 2.723 0 0 1 4.492 2.07v3.102l-.001.104v4.859c0 1.431-.848 3.878-2.51 6.022a9.11 9.11 0 0 1-.537.65a9.206 9.206 0 0 1-6.832 3.008a9.196 9.196 0 0 1-7.577-3.944c-.604-.833-.892-1.507-1.179-2.176c-.22-.513-.438-1.023-.796-1.601c-.567-.913-1.4-1.59-1.865-1.969l-.099-.08h.002l-2.847-2.093Z"
        />
        <path
          fill="url(#pointingupsvgIDg)"
          d="M4.116 18.12c-1.24-.86-1.701-2.597-.888-3.849a2.657 2.657 0 0 1 3.703-.781l2.61 1.695V4.655a2.637 2.637 0 0 1 5.274 0v4.284a2.493 2.493 0 0 1 4.563.344a2.724 2.724 0 0 1 4.487.884a2.723 2.723 0 0 1 4.492 2.07v3.102l-.001.104v4.859c0 1.431-.848 3.878-2.51 6.022a9.11 9.11 0 0 1-.537.65a9.206 9.206 0 0 1-6.832 3.008a9.196 9.196 0 0 1-7.577-3.944c-.604-.833-.892-1.507-1.179-2.176c-.22-.513-.438-1.023-.796-1.601c-.567-.913-1.4-1.59-1.865-1.969l-.099-.08h.002l-2.847-2.093Z"
        />
        <path
          fill="url(#pointingupsvgIDh)"
          d="M4.116 18.12c-1.24-.86-1.701-2.597-.888-3.849a2.657 2.657 0 0 1 3.703-.781l2.61 1.695V4.655a2.637 2.637 0 0 1 5.274 0v4.284a2.493 2.493 0 0 1 4.563.344a2.724 2.724 0 0 1 4.487.884a2.723 2.723 0 0 1 4.492 2.07v3.102l-.001.104v4.859c0 1.431-.848 3.878-2.51 6.022a9.11 9.11 0 0 1-.537.65a9.206 9.206 0 0 1-6.832 3.008a9.196 9.196 0 0 1-7.577-3.944c-.604-.833-.892-1.507-1.179-2.176c-.22-.513-.438-1.023-.796-1.601c-.567-.913-1.4-1.59-1.865-1.969l-.099-.08h.002l-2.847-2.093Z"
        />
      </g>
      <rect
        width="14.864"
        height="5.274"
        fill="url(#pointingupsvgIDi)"
        rx="2.637"
        transform="matrix(0 1 1 0 9.54 2.018)"
      />
      <rect
        width="14.864"
        height="5.274"
        fill="url(#pointingupsvgIDj)"
        rx="2.637"
        transform="matrix(0 1 1 0 9.54 2.018)"
      />
      <rect
        width="14.864"
        height="5.274"
        fill="url(#pointingupsvgIDk)"
        rx="2.637"
        transform="matrix(0 1 1 0 9.54 2.018)"
      />
      <g filter="url(#pointingupsvgIDl)">
        <rect
          width="11.359"
          height="1.869"
          fill="url(#pointingupsvgIDm)"
          rx=".934"
          transform="matrix(0 1 1 0 11.957 3.205)"
        />
      </g>
      <g filter="url(#pointingupsvgIDn)">
        <rect
          width="8.33"
          height="2.167"
          fill="url(#pointingupsvgIDo)"
          rx="1.083"
          transform="scale(1 -1) rotate(-32.82 -23.788 -14.853)"
        />
      </g>
      <g filter="url(#pointingupsvgIDp)">
        <rect
          width="4.885"
          height="1.908"
          fill="url(#pointingupsvgIDq)"
          rx=".954"
          transform="matrix(0 1 1 0 16.682 8.559)"
        />
      </g>
      <g filter="url(#pointingupsvgIDr)">
        <rect
          width="4.885"
          height="1.908"
          fill="url(#pointingupsvgIDs)"
          rx=".954"
          transform="matrix(0 1 1 0 21.313 9.68)"
        />
      </g>
      <g filter="url(#pointingupsvgIDt)">
        <rect
          width="4.885"
          height="1.908"
          fill="url(#pointingupsvgIDu)"
          rx=".954"
          transform="matrix(0 1 1 0 25.943 10.801)"
        />
      </g>
      <path fill="url(#pointingupsvgIDv)" d="M17.185 7.613v6.422h-2.37V8.939a2.493 2.493 0 0 1 2.37-1.326Z" />
      <defs>
        <linearGradient id="pointingupsvgIDh" x1="24.342" x2="28.358" y1="16" y2="16" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFE040" stop-opacity="0" />
          <stop offset="1" stop-color="#FFE040" />
        </linearGradient>
        <linearGradient
          id="pointingupsvgIDi"
          x1="5.442"
          x2="5.442"
          y1="-1.384"
          y2="1.992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E7942D" />
          <stop offset="1" stop-color="#E7942D" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="pointingupsvgIDj"
          x1="14.104"
          x2="12.027"
          y1="4.026"
          y2="4.026"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFBC3D" />
          <stop offset="1" stop-color="#FFBC3D" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="pointingupsvgIDk"
          x1="5.622"
          x2="7.432"
          y1="7.661"
          y2="3.593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE949" />
          <stop offset="1" stop-color="#FFE949" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="pointingupsvgIDm"
          x1="3.241"
          x2="13.642"
          y1="2.079"
          y2="2.079"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE746" />
          <stop offset="1" stop-color="#FFE746" stop-opacity="0" />
        </linearGradient>
        <linearGradient id="pointingupsvgIDo" x1="1.233" x2="6.169" y1=".935" y2="1.153" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFD12D" />
          <stop offset="1" stop-color="#FFD12D" stop-opacity="0" />
        </linearGradient>
        <linearGradient id="pointingupsvgIDq" x1=".467" x2="4.885" y1=".954" y2=".954" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFE23F" />
          <stop offset="1" stop-color="#FFE23F" stop-opacity="0" />
        </linearGradient>
        <linearGradient id="pointingupsvgIDs" x1=".467" x2="4.885" y1=".954" y2=".954" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFE23F" />
          <stop offset="1" stop-color="#FFE23F" stop-opacity="0" />
        </linearGradient>
        <linearGradient id="pointingupsvgIDu" x1=".467" x2="4.885" y1=".954" y2=".954" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFE23F" />
          <stop offset="1" stop-color="#FFE23F" stop-opacity="0" />
        </linearGradient>
        <radialGradient
          id="pointingupsvgIDb"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(123.538 9.147 13.205) scale(20.5218 30.2361)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFD03F" />
          <stop offset="1" stop-color="#FEAD3A" />
        </radialGradient>
        <radialGradient
          id="pointingupsvgIDc"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 5.75553 -1.47134 0 15.86 8.766)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DCA42D" />
          <stop offset="1" stop-color="#DCA42D" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="pointingupsvgIDd"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 7.14032 -1.53295 0 20.404 7.9)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DCA42D" />
          <stop offset="1" stop-color="#DCA42D" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="pointingupsvgIDe"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 5.92863 -1.27281 0 24.818 9.328)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DCA42D" />
          <stop offset="1" stop-color="#DCA42D" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="pointingupsvgIDf"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 2.375 -.20313 0 23.848 10.169)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B65B01" />
          <stop offset="1" stop-color="#B65B01" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="pointingupsvgIDg"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 3.80817 -.3257 0 19.452 7.987)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B65B01" />
          <stop offset="1" stop-color="#B65B01" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="pointingupsvgIDv"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.82222 -3.49518 .7984 .18782 14.389 11.102)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8F4709" />
          <stop offset="1" stop-color="#8F4709" stop-opacity="0" />
        </radialGradient>
        <filter id="pointingupsvgIDa" width="26.537" height="28.714" x="2.821" y="1.268" filterUnits="userSpaceOnUse">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dx="1" dy="-.75" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0.901961 0 0 0 0 0.513726 0 0 0 0 0.258824 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow_20020_5201" />
        </filter>
        <filter id="pointingupsvgIDl" width="4.869" height="14.359" x="10.457" y="1.705" filterUnits="userSpaceOnUse">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_20020_5201" stdDeviation=".75" />
        </filter>
        <filter id="pointingupsvgIDn" width="10.346" height="8.507" x="3.168" y="12.357" filterUnits="userSpaceOnUse">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_20020_5201" stdDeviation=".75" />
        </filter>
        <filter id="pointingupsvgIDp" width="3.908" height="6.885" x="15.682" y="7.559" filterUnits="userSpaceOnUse">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_20020_5201" stdDeviation=".5" />
        </filter>
        <filter id="pointingupsvgIDr" width="3.908" height="6.885" x="20.313" y="8.68" filterUnits="userSpaceOnUse">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_20020_5201" stdDeviation=".5" />
        </filter>
        <filter id="pointingupsvgIDt" width="3.908" height="6.885" x="24.943" y="9.801" filterUnits="userSpaceOnUse">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_20020_5201" stdDeviation=".5" />
        </filter>
      </defs>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FluentEmojiBackhandIndexPointingUp',
}
</script>
